export default "__VITE_ASSET__a19660fb__"